export const ru = {
    'audience-and-metrika': 'Яндекс.Аудитории и Яндекс.Метрика',
    copied: 'Скопировано',
    'copy-error': 'Ошибка при копировании',
    'copy-link': 'Копировать настройки группы в буфер обмена',
    ots: 'OTS',
    'predictor-detailed': '{sum} миллионов',
    'predictor-detailed-less': '< {sum}',
    'predictor-error': 'Прогноз временно недоступен',
    'predictor-settings': 'Настройки группы объявлений',
    'predictor-sum': 'из {sum} млн',
    'predictor-sum-from': 'из {sum}',
    'predictor-sum-less': 'из < {sum}',
    'reach-title': 'Показы',
    'reach-title-ots': 'Охват аудитории'
};
